const COMPANY = {
    COMPANYNAME: 'CN',
    COMPANYFEIN: 'CF',
    PHONENUMBER: 'CPN',
    WEBSITE: 'CWEB',
    EMAIL: 'CE',
    DOINGBUSINESS: 'DBA',
    BUSINESSOWNERSHIP: 'BOI',
    GEOGRAPHICMARKET: 'GMI',
    BUSINESSPREMISES: 'BPI',
    BUSINESSACQUIREMENT: 'BAI',
    YEARBUSINESSFORMED: 'YBF',
    YEARVETERANCOMPANY: 'YVC',
    DECFORM: 'DF',
    DECSUPDOC: 'DSD',
    GROSSREVENUEFIRST: 'GRFY',
    GROSSREVENUESECOND: 'GRSY',
    APPFEEPAID: 'AFP',
    GROSSREVENUESUPDOC: 'GRSD'
};

const VETERAN = {
    OWNERSSN: 'OS',
    MILITARYNUMBER: 'MIN',
    FIRSTNAME: 'FN',
    LASTNAME: 'LN',
    TITLE: 'VT',
    GENDERCODE: 'VGC',
    ETHNICITY: 'EI',
    EMAIL: 'VE',
    COMPANYHELD: 'CHP',
    PHONENUMBER: 'VPN',
    OWNERRESUME: 'OR',
    OWNERVETERAN: 'OV',
    NONVETERANCONTRIB: 'NVC',
    SERVICEBRANCH: 'SBI',
    SF180UPLOAD: 'SFU',
    SF180FORM: 'SFD',
    SF180SENTDATE: 'SFS',
    PROOFCITIZENSHIP: 'PCU',
    VETERANSERVICEDISABLED: 'VSCD',
    BENEFITVETLETTER: 'BVL',
    DATEOFBIRTH: 'VDB'
};

const POINT_OF_CONTACT = {
    FIRSTNAME: 'PFN',
    LASTNAME: 'PLN',
    TITLE: 'PT',
    EMAIL: 'PE'
};

const BUSINESS = {
    CAPSTATEMENT: 'CS',
    PROFACCREDITATION: 'PA',
    CAPUPLOAD: 'CU',
    ACRUPLOAD: 'AU',
    SHARERESQUESTION: 'SRQ',
    SUBSIDIARYQUESTION: 'SQ',
    OTHERAGREEMENT: 'OAQ',
    SHARERESDESC: 'SRD',
    SUBSIDIARYDESC: 'SD',
    AGRUPLOAD: 'UA',
    AFFECTEDLISTUPOAD: 'ALU',
    COLISTUPLOAD: 'CLU',
    NAICSCODES: 'NC',
    NUMBERFULLTIMEEE:'NFTE',
    NUMBERVETERANEE: 'NVE',
    NUMBERPARTTIMEEE: 'NPTE',
    NUMBERPARTTIMECTR: 'NPTC'
};

const CERTIFICATION = {
    NMSDC: 'NMSDC',
    NMSDCEXPDATE: 'NMSDCED',
    WBENC: 'WBENC',
    WBENCEXPDATE: 'WBENCED',
    NGLCC: 'NGLCC',
    NGLCCEXPDATE: 'NGLCCED',
    CVE: 'CVE',
    SBA8: 'SBA8',
    SBAHUBZONE: 'SBAHZ',
    DISVETBUSENT: 'DVBE',
    NAVOBA: 'NAVOBA',
    DISABILITY: 'DI',
    NONEOFABOVE: 'NN'
};

const FINANCE = {
    FACUPLOAD: 'FU',
    CURRYTDUPLOAD: 'CYTDU',
    NPAYABLEUPLOAD: 'NPU',
    OCCLICUPLOAD: 'OLU',
    OPPERUPLOAD: 'OPU',
    YDTPUPLOAD: 'YDTPU',
    BONDINGCUPLOAD: 'PBCU',
};

const BANKING = {
    FINANCIALINST: 'FI',
    ACCOUNTMGR: 'AM',
    PHONENUMBER: 'BPN',
    BANKAPPROVEDCL: 'BACL',
    TYPEBANKACCOUNT: 'TBA',
    BANKACCOUNTCR: 'BACR',
    BANKSIGNATURECARD: 'BSC',
    CANCELLEDCHECKS: 'CC'
};

const TAX = {
    BIZLETTER: 'BL',
    PRIORBIZLETTER: 'PBL',
    PERSLETTER: 'PL',
    PRIORPERSLETTER: 'PPL'
};

const EQUIPMENT = {
    ACTIVEASSETAGR: 'AAA',
    EQUIPMENTLEASEAGR: 'ELA',
    EQUIPMENTLOC: 'EL',
    DOLLARAMOUNTEQINV: 'DAEI',
    PERSONALHOMERES: 'PHR',
    COMPANYLOC: 'CL',
    WAREHOUSELOC: 'WL',
    GARAGELOC: 'GL',
    MOBILESTORAGELOC: 'MSL'
};

const ARTICLE = {
    INCARTICLESUPLOAD: 'IAU',
    INCCERTIFICATEUPLOAD: 'ICU',
    ORGARTICLEUPLOAD: 'AOOU',
    ORGCERTIFICATEUPLOAD: 'COOU',
    CORPLAWSUPLOAD: 'CBLU',
    FIRSTBDMEETINGMINUPLOAD: 'FBMMU',
    MOSTREMEETINGMINUPLOAD: 'MRMMU',
    BUYOUTRIGHTSUPLOAD: 'BORU',
    LIMITEDPTRCERUPLOAD: 'LPCU',
    PARTNERSHIPAGRUPLOAD: 'PAU',
    CAPITALCONTRIBUPLOAD: 'CCPU',
    FOREIGNENTCERUPLOAD: 'FECU',
    STOCKPURUPLOAD: 'SPPU',
    CORPORATESTOCKCERUPLOAD: 'CSCU',
    CORPORATESTOCKLEDUPLOAD: 'CSLU',
    PROFITSHARUPLOAD: 'PSU',
    THIRDPARTYAGRUPLOAD: 'TPAU',
    OPERATIONALAGRUPLOAD: 'OAU',
    MINUTESLASTMEETINGUPLOAD: 'MLMOE',
    CAPINVESTPROOF: 'PCIU',
    ORGORFIRSTMEETINGUPLOAD: 'MOMM',
    MINLASTMEETINGMEMBERSUPLOAD: 'MLMMIE',
    MINFIRSTMEMBERMEETINGUPLOAD: 'MFMM',
    MINLASTMEMBERMEETINGUPLOAD: 'MLMMU',
    UNITPURCHASEPROOFUPLOAD: 'PUP',
    CORPMEMBERUNITCERTUPLOAD: 'CMUC',
    CURRENTUNITLEDBOOKUPLOAD: 'CMULD',
    GENLIMPARTCORPDOCUPLOAD: 'GLPCD'
};

const DECLARATION = {
    DECLARATIONCERUPLOAD: 'DCU'
};

const PREQUALIFICATION = {
    QUALIFYVETERAN: 'PQV',
    DISHONORABLEVETERAN: 'PDV',
    CADETVETERAN: 'PCV',
    VETERANOWNERSHIP: 'VOO',
    LEGALAUTHORITY: 'VLA',
    SERVICECONNECTED: 'VSCDS',
    ACTIVEMANAGMENTPROOF: 'VAM',
    VETERANEXPERIENCE: 'VCE'
};

const REGISTRATION = {
    COMPANY_NAME: 'RCN',
    COMPANY_FEIN: 'RFEIN',
    COMPANY_PREVIOUS_YEAR_AMOUNT: 'RY1A',
    COMPANY_PRIOR_TO_PREVIOUS_YEAR_AMOUNT: 'RY2A',
    COMPANY_WEBSITE: 'RCW',
    VETERAN_FIRST_NAME: 'RVFN',
    VETERAN_LAST_NAME: 'RVLN',
    VETERAN_LOGIN_ID: 'RLID',
    VETERAN_CELL_PHONE: 'RVCP',
    PASSWORD: 'RPWD',
    CONFIRM_PASSWORD: 'RCPWD',
    VETERAN_EMAIL: 'RVEA',
    PREQUAL_QUESTION_1: 'RQ1',
    PREQUAL_QUESTION_2: 'RQ2',
    PREQUAL_QUESTION_3: 'RQ3',
    PREQUAL_QUESTION_4: 'RQ4',
    PREQUAL_QUESTION_5: 'RQ5'
};

export default {
    COMPANY,
    VETERAN,
    POINT_OF_CONTACT,
    BUSINESS,
    CERTIFICATION,
    FINANCE,
    BANKING,
    TAX,
    EQUIPMENT,
    ARTICLE,
    DECLARATION,
    PREQUALIFICATION,
    REGISTRATION
}


// WEBPACK FOOTER //
// ./src/areas/shared/consts/TooltipCode.js